/* eslint-disable react/prop-types */
import ReactApexChart from 'react-apexcharts';
// material
import { styled } from '@mui/material/styles';
import { Box, Card, CardHeader } from '@mui/material';
// utils

// ----------------------------------------------------------------------
const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(5),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

export default function StatsPie({ dataStat }) {
  const datas = {
    series: [
      {
        name: 'Desktops',
        data: dataStat
      }
    ],
    options: {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      xaxis: {
        categories: ['Brute', 'Traitement en cours', 'Délibérée']
      }
    }
  };

  return (
    <Card>
      <CardHeader title="Tendances des plaintes" subheader="Comtel Bénin" />
      <Box sx={{ mx: 3 }} dir="ltr">
        <ChartWrapperStyle dir="ltr">
          {' '}
          <ReactApexChart type="bar" series={datas.series} options={datas.options} height={364} />
        </ChartWrapperStyle>
      </Box>
    </Card>
  );
}
